import { render, staticRenderFns } from "./MainLedgerStatement.vue?vue&type=template&id=032bdeb7&scoped=true"
import script from "./MainLedgerStatement.vue?vue&type=script&lang=js"
export * from "./MainLedgerStatement.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerStatement.vue?vue&type=style&index=0&id=032bdeb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032bdeb7",
  null
  
)

export default component.exports